/** @format */

import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import PlatformUser from '../../interfaces/platform/PlatformUser';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { platformUserConstants } from '../../modules/platformuser/actions';
import { PlatformUserModify, PlatformUserSendType } from './PlatformUserModify';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import { useLocation } from 'react-router-dom';

export type PlatformUserEditType = {
    match: any;
};

export const PlatformUserEdit: FunctionComponent<PlatformUserEditType> = ({ match }): React.ReactElement => {
    const dispatch = useDispatch();
    const id = useMemo((): string | null => {
        return match?.params?.id;
    }, [match]);
    const location = useLocation();
    const [resellerId, setResellerId] = useState<string | null>(null);
    const [platformUser, setPlatformUser] = useState<PlatformUser|null>(null)

    const [outputObject, setOutputObject] = useState<PlatformUserSendType>({
        personName: '',
        username: '',
        email: '',
        activatedAt: null,
        systemAccount: false,
        certificateSerialHash: null,
        certificateValidTo: null,
    });

    const savePlatformUser = (outputObject: PlatformUserSendType, errors?: Array<string>): void => {
        if (!id) {
            return;
        }

        if (outputObject.newPassword === '') {
            outputObject.newPassword = null;
        }

        if (!outputObject.activatedAt) {
            outputObject.activatedAt = DateHelperTs.getCurrentDateTime();
        }

        if (errors && errors?.length > 0) {
            errors?.forEach((el: any) => {
                NotificationHelper.notifyError(el, dispatch);
            });

            return;
        }

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.putWithCallback(FormGeneralHelper.getByUri(id), platformUserConstants.SAVE_ITEM, outputObject, (): void => {
            setOutputObject({...outputObject, newPassword: null, repeatPassword: null})
        }, {
            dispatchAfterCallback: true,
            dispatchErrorAfterCallback: true,
        });
    };

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (location && location.state && location.state.platformResellerId) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            setResellerId(location.state.platformResellerId);
        }
    }, [location]);

    useEffect(() => {
        if (!id) {
            return;
        }

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getWithCallback(
            FormGeneralHelper.getByUri(id),
            platformUserConstants.ITEM,
            (data: PlatformUser): void => {
                const tmpOutputObject = {
                    id: data.id ?? null,
                    personName: data.personName ?? '',
                    username: data.username ?? '',
                    email: data.email ?? '',
                    permissionGroupId: data.permissionGroupId ?? null,
                    activatedAt: data.activatedAt ?? '',
                    allowGenericLogin: data.allowGenericLogin ?? true,
                    accountExpiration: data.accountExpiration ?? null,
                    systemAccount: data.systemAccount ?? null,
                } as PlatformUserSendType;
                setOutputObject(tmpOutputObject);
                setPlatformUser(data);
            },
            { dispatchAfterCallback: false, propagateDataToCallback: true, dispatchErrorAfterCallback: true }
        );
    }, [dispatch, id]);

    return (
        <PlatformUserModify
            resellerId={resellerId}
            platformUser={platformUser}
            userId={outputObject.id ? outputObject.id.toString() : null}
            outputObject={outputObject}
            savePlatformUser={savePlatformUser}
        />
    );
};
